var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"427ccb950c2bdc64942e6a9ba1777d5abf852fed"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-registration@docupet"]={id:"427ccb950c2bdc64942e6a9ba1777d5abf852fed"};
      